import React from 'react';
import {View, Platform} from 'react-native';
import Checkbox from '../../elements/Checkbox';
import Input from '../../elements/Input';
import styles from './styles';
import {tID} from '../../../utils/TestIdHelper';
import Text from '../../elements/Text';
import {ClosedEyeIcon, OpenEyeIcon} from '../../../utils/SvgIcons';
import {getBiometricLabel} from '../../../utils/HelperMethods';
import {useTheme} from '../../../theme';

const SignInInputForm = ({
  // Only offer biometric enable when the device actually reports an enrolled,
  // usable biometric — offering it and then failing is worse than not asking.
  showBiometricOption = false,
  checkboxSelected = false,
  onPressCheckbox,
  email,
  onChangeEmail,
  password,
  onChangePassword,
  showPassword,
  onPressShowPassword,
  hasError,
  errorText,
  hasEmailError,
  hasPasswordError,
}) => {
  // The shared Input element still hardcodes light-palette text/placeholder
  // colors (its theming is a later tranche). Until then, override per-field —
  // light textPrimary/textMuted ARE the exact legacy values, so light mode is
  // unchanged; dark mode gets readable input text instead of dark-on-dark.
  const {colors} = useTheme();
  const themedInput = {color: colors.textPrimary};
  return (
    <>
      <View style={styles.container}>
        <Input
          hasError={hasError || hasEmailError}
          errorText={hasEmailError ? 'Please enter a valid email address.' : ''}
          placeholder={'Type here...'}
          inputTitle={'Email'}
          value={email}
          onChangeText={onChangeEmail}
          keyboardType={'email-address'}
          autoCapitalize="none"
          autoCorrect={false}
          textContentType="username"
          autoComplete="username"
          inputStyle={themedInput}
          placeholderTextColor={colors.textMuted}
          testID={tID('SignIn-SignInInputForm-EmailInput')}
          containerStyle={Platform.OS === 'web' && styles.flex1Width292}
        />
        <Input
          hasError={hasError || hasPasswordError}
          errorText={
            hasPasswordError
              ? 'Password doesn’t meet the requirements.'
              : Platform.OS != 'web' && errorText
          }
          secureTextEntry={!showPassword}
          textContentType="password"
          autoComplete="current-password"
          inputTitle={'Password'}
          placeholder={'Type here...'}
          value={password}
          onChangeText={onChangePassword}
          topMargin={Platform.OS === 'web' ? 0 : 24}
          rightIcon={showPassword ? <OpenEyeIcon /> : <ClosedEyeIcon />}
          onPressRightIcon={onPressShowPassword}
          inputStyle={themedInput}
          placeholderTextColor={colors.textMuted}
          testID={tID('SignIn-SignInInputForm-PasswordInput')}
          containerStyle={Platform.OS === 'web' && styles.flex1Width292}
        />

        {Platform.OS != 'web' && showBiometricOption && (
          <Checkbox
            title={`Check here to enable ${getBiometricLabel()}.`}
            selected={checkboxSelected}
            onPress={onPressCheckbox}
            testID={tID('SignIn-SignInInputForm-Checkbox')}
          />
        )}
      </View>
      {hasError && Platform.OS === 'web' && (
        <Text
          topMargin={16}
          testID={tID('SignIn-Text-Error')}
          color={colors.danger}
          variation="Text1Regular">
          {errorText}
        </Text>
      )}
    </>
  );
};

export default SignInInputForm;

////The added testIds have the following structure
// SignIn-SignInInputForm-EmailInput
// SignIn-SignInInputForm-PasswordInput
// SignIn-SignInInputForm-Checkbox
